//Generated File 
export default class GUIActionResultType{
	static readonly BarcodePrint = `BarcodePrint`;
	static readonly ExternalURL = `ExternalURL`;
	static readonly GoToPlace = `GoToPlace`;
	static readonly InternalURL = `InternalURL`;
	static readonly NewRecord = `NewRecord`;
	static readonly NewRecordInPopup = `NewRecordInPopup`;
	static readonly PopupListView = `PopupListView`;
	static readonly TextToCopy = `TextToCopy`;
	static readonly UpdateList = `UpdateList`;
}
